export function isDesignsPanelSupported(page: eXpress.core.IZone | null | undefined) {
	return !!page?.definition?.product?.showDesigns;
}
